/* global axios */
import ApiClient from './ApiClient';

class SlaAPI extends ApiClient {
  constructor() {
    super('sla_policies', { accountScoped: true });
  }

  get() {
    return axios.get(`${this.url}`);
  }

  create(params) {
    return axios.post(`${this.url}`, params);
  }

  update(id, params) {
    return axios.patch(`${this.url}/${id}`, params);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new SlaAPI();
